module.exports = __webpack_public_path__ + "static/img/update20240119.3b314587.jpg";